import messageApi from './components/message-api'
import { getRootAppWindow } from 'meta/utils/getRootAppWindow'

class HKManager {
    constructor() {
        // a dictionary where values are keys (pressed on keyboard) and values names of iframes, that should respond to that key press
        this.frameKeyBindings = {}

        messageApi.on('hotkeys.bind', ({data: {key, triggerWhileInTextField}, source: {name}}) => {
            this.frameKeyBindings[key] = {frameName: name, triggerWhileInTextField}
            this.broadcast(name, 'hotkeys.updateClient', {frameKeyBindings: this.frameKeyBindings})

            return this.frameKeyBindings
        })

        messageApi.on('hotkeys.unbind', ({data: {key}, source: {name}}) => {
            delete this.frameKeyBindings[key]
            this.broadcast(name, 'hotkeys.unbindClient', {key})

            return this.frameKeyBindings
        })

        messageApi.on('hotkeys.reset', ({source: {name}}) => {
            this.frameKeyBindings = {}
            this.broadcast(name, 'hotkeys.resetClient')

            return this.frameKeyBindings
        })

        messageApi.on('hotkeys.init', () => {
            return this.frameKeyBindings
        })

        messageApi.on('hotkeys.unload', ({source: {name}}) => {
            for (const key in this.frameKeyBindings) {
                if (this.frameKeyBindings[key] === name) delete this.frameKeyBindings[key]
            }
            this.broadcast(name, 'hotkeys.updateClient', {frameKeyBindings: this.frameKeyBindings})
        })
    }

    broadcast(exceptFrame, action, data) {
        const topFrame = getRootAppWindow(window);
        let frames = [].slice.call(topFrame.frames, 0)

        if (topFrame.name !== exceptFrame) frames.push(topFrame)
        
        frames.filter(f => f.name !== exceptFrame).forEach(f => messageApi.send(f, action, data))
    }
}

export default HKManager
